import { API } from '../../config/api';
import { DataService } from '../../config/dataService/dataService';

// Personal details fetch
export const vehicleDetails = (limits, pages, userId) => {
    return async (dispatch) => {
        try {
            console.log('🚀 ~ vehicleDetails ~ userId:', userId);
            const response = await DataService.get(`${API.vehicle.getVehicleListByUserID}/${userId}?page=1&limit=500`);
            if (!response.data.error) {
                dispatch({
                    type: API.vehicle.getVehicleListByUserID,
                    vehicleData: response.data.data,
                    loading: false,
                });
                return response.data.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const vehicleYear = (pages, limits) => {
    return async () => {
        try {
            const response = await DataService.get(`${API.vehicle.getVehicleYearList}?page=${pages}&limit=${limits}`);
            if (!response.data.error) {
                return response.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const vehicleMake = (pages, limits, year) => {
    return async () => {
        try {
            console.log('🚀 ~ vehicleMake ~ year:', year);
            const response = await DataService.get(`${API.vehicle.getVehicleMakeList}?page=${pages}&limit=${limits}&year=${year}`);
            if (!response.data.error) {
                return response.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const vehicleModel = (pages, limits, id, year) => {
    return async () => {
        try {
            const response = await DataService.get(
                `${API.vehicle.getVehicleExperimentalModelList}?page=${pages}&limit=${limits}&vehicleMakeId=${id}&year=${year}`
            );
            if (!response.data.error) {
                return response.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const checkFleetNumberExists = async (payload) => {
    try {
        const response = await DataService.post(API.vehicle.check, payload);
        if (response.data.status) {
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};
export const fetchProvinces = () => {
    return async (dispatch) => {
        try {
            const response = await DataService.get(`${API.vehicle.getProvinces}`);
            if (!response.data.error) {
                dispatch({
                    type: API.vehicle.getProvinces,
                    provinces: response.data.data,
                    loading: false,
                });
                return response.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
